import Button from "~/components/ui/button/Button.tsx";
import Modal from "~/components/ui/modal/Modal.tsx";

interface DeleteHostnameModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isDeleting?: boolean;
}

export const DeleteHostnameModal = ({
  isOpen,
  onClose,
  onConfirm,
  isDeleting = false,
}: DeleteHostnameModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      modalLabel={<h3>Are you sure you want to remove this hostname?</h3>}
      closeModal={onClose}
    >
      <div style={{ display: "flex", gap: "1rem", justifyContent: "flex-end" }}>
        <Button outlined onClick={onClose}>
          Cancel
        </Button>
        <Button
          danger
          withSpinner={isDeleting}
          onClick={async () => {
            onConfirm();
            onClose();
          }}
        >
          Remove
        </Button>
      </div>
    </Modal>
  );
};
